import React, { useEffect } from 'react';

import {
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  Route,
  Switch,
  useHistory,
} from 'react-router-dom';

import { Helmet } from '../../../../components/Helmet';
import { WagRedirect } from '../../../../components/WagRedirect';
import {
  Routes,
  ROUTE_SIGNUP,
  WEBVIEW_URL_CURRENT,
  WEBVIEW_SEARCH_CURRENT,
} from '../../../../constants';
import { isInEmbed } from '../../../../hooks';
import { useGetWalkerFromUrlQuery } from '../../../../hooks/useGetWalkerFromUrlQuery';
import { ownerSlice } from '../../../../slices/owners';

import { AddressInfo } from './components/AddressInfo';
import { Complete } from './components/Complete';
import { OwnerExists } from './components/OwnerExists';
import { OwnerInfo } from './components/OwnerInfo';
import { PetInfoPart1 } from './components/PetInfoPart1';
import { PetInfoPart2 } from './components/PetInfoPart2';

/**
 * Container used to wrap each step of the signup flow together
 *
 * @confluence https://wagsters.atlassian.net/wiki/spaces/WEB/pages/1350500353/Web%2BConcierge%2BSignup%2BFlow%2BMixpanel%2BTracking%2BDetails
 */
export const SignUpContainer = () => {
  const history = useHistory();

  const {
    push,
    location,
  } = history;

  useEffect(() => {
    if (!isInEmbed) {
      return;
    }
    // Set the current path in localStorage for persistence
    window.localStorage.setItem(WEBVIEW_SEARCH_CURRENT, location.search);
    if (location.pathname !== ROUTE_SIGNUP) {
      window.localStorage.setItem(WEBVIEW_URL_CURRENT, location.pathname);
    }
    const currentLocationPathname = window.localStorage.getItem(WEBVIEW_URL_CURRENT);
    const currentLocationSearch = window.localStorage.getItem(WEBVIEW_SEARCH_CURRENT);

    /*
      Checks if a variable exists in localStorage
      for the webview url and if it equals the current path
    */
    if (currentLocationPathname && currentLocationPathname !== location.pathname) {
      push({
        pathname: currentLocationPathname,
        search: currentLocationSearch as string,
      });
    }
  });
  const walker = useGetWalkerFromUrlQuery();

  const dispatch = useDispatch();

  const walkerInState = useSelector(ownerSlice.selectors.getDirectBookingWalker);

  useEffect(() => {
    if (JSON.stringify(walkerInState) === JSON.stringify(walker)) {
      return;
    }
    dispatch(ownerSlice.actions.setDirectBookingWalker(walker));
  }, [walker, walkerInState, dispatch]);
  return (
    <Switch>
      <Route
        path={Routes.SignupBasicInfo}
      >
        <Helmet>
          <title>Signup - Basic Info</title>
        </Helmet>
        <OwnerInfo />
      </Route>

      {isInEmbed && (
        <Route
          path={Routes.SignupOwnerExists}
        >
          <OwnerExists />
        </Route>
      )}

      <Route
        exact
        path={Routes.SignupPetInfoPart1}
      >
        <Helmet>
          <title>Signup - Pet Info</title>
        </Helmet>
        <PetInfoPart1 />
      </Route>

      <Route
        path={Routes.SignupPetInfoPart2}
      >
        <Helmet>
          <title>Signup - Pet Info</title>
        </Helmet>
        <PetInfoPart2 />
      </Route>

      <Route
        path={Routes.SignupAddress}
      >
        <Helmet>
          <title>Signup - Address Info</title>
        </Helmet>
        <AddressInfo />
      </Route>

      <Route
        path={Routes.SignupComplete}
      >
        <Helmet>
          <title>Signup - Complete</title>
        </Helmet>
        <Complete
          walkerName={walker.name}
        />
      </Route>

      <WagRedirect
        to={{
          path: Routes.SignupBasicInfo,
        }}
      />
    </Switch>
  );
};
